import React from "react";


const Header = () => {
  return (
    <header className="bg-violet-900 text-white p-4 flex justify-between items-center">
      <div className="text-2xl font-bold">CryptoCap</div>
      <nav className="hidden md:flex space-x-6">
        <a href="#" className="hover:text-purple-400">Home</a>
        <a href="#" className="hover:text-purple-400">Businesses</a>
        <a href="#" className="hover:text-purple-400">Trade</a>
        <a href="#" className="hover:text-purple-400">Market</a>
        <a href="#" className="hover:text-purple-400">Learn</a>
      </nav>
      <div className="flex items-center space-x-4">
        <select className="bg-gray-800 text-white p-1 rounded">
          <option>EN</option>
          <option>FR</option>
        </select>
        <button className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600">
          Login
        </button>
      </div>
    </header>
  );
};

export default Header;